import { memo, useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';
import {
    useOptimizelyTrack,
} from '@atc/optimizely-toolkit';

import { sendClick } from 'reaxl-analytics';

import {
    query,
    removeParameters,
} from '@/utilities/QueryStringUtil';
import { saveVDPListing } from '@/utilities/saveListing';
import saveRecentInventory from '@/utilities/saveRecentInventory';
import sendAlertClickHandler from '@/utilities/sendAlertClickHandler';

import paymentsDuck from '@/ducks/paymentsDuck.js';
import savedInventoryDuck from '@/ducks/savedInventoryDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

// Utilities

import HeaderContentContainer from '@/containers/HeaderContentContainer';

let saveListingParam = query().saveListing;
removeParameters('saveListing');

export function VDPHeaderContainer() {
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const hasUpdatedWallet = useSelector((state) => paymentsDuck.selectors.getMyWalletInteraction(state, 'hasUpdatedWallet'));
    const savedListingIds = useSelector(savedInventoryDuck.selectors.getSavedInventoryIds);
    const isSaved = savedListingIds?.includes(listing.id) ?? false;

    const dispatch = useDispatch();
    const optimizelyTrack = useOptimizelyTrack();

    const { vehicle_header_content: [enableHeaderContent] } = useFeatures(['vehicle_header_content']);

    useEffect(() => {
        if (listing.id) {
            dispatch(saveRecentInventory(listing.id));
        }
    }, [dispatch, listing.id]);

    useEffect(() => {
        if (listing.accelerate && hasUpdatedWallet) {
            optimizelyTrack('total_value', { value: 0.14 });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listing.accelerate, hasUpdatedWallet]);
    const handleSaveVDPListing = useCallback((data) => {
        dispatch(saveVDPListing(data));
    }, [dispatch]);

    const autoSaveListing = () => {
        if (saveListingParam && !isSaved) {
            handleSaveVDPListing({
                event: {},
                listing,
                wasSaved: false,
                sendClick,
            });
            saveListingParam = false;
        }
    };
    return (
        <HeaderContentContainer
            onLoggedInStateReady={autoSaveListing}
            showHeaderContent={enableHeaderContent}
            saveListing={handleSaveVDPListing}
            sendAlertClickHandler={useCallback(sendAlertClickHandler, [])}
        />
    );
}

export default memo(VDPHeaderContainer);
